program Portal_TEKNIA;



{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  Login_View in 'src\Login_View.pas'{*.html},
  Main_View in 'Main_View.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TLoginView, LoginView);
  Application.Run;
end.
